<div class="flex p-fluid p-form-view-data">
  <div class="md:col-span-6 pr-4">
    <label class="normal-font-size-bold flex mb-1">General Information</label>
    <div class="card-grid small-gap">
      <label>NPI:</label>
      <div>{{ physicianTableData?.practiceNpinumber | emptyPlaceholder }}</div>

      @if (!isExternalUser) {
        <label>Portal Provider ID:</label>
        <div>{{ physicianTableData?.accountId | emptyPlaceholder }}</div>
      }

      <label>Tax ID:</label>
      <div>{{ physicianTableData?.practiceTaxId | emptyPlaceholder }}</div>

      @if (!isExternalUser) {
        <label>Provider Type:</label>
        <div>{{ physicianTableData?.providerType | emptyPlaceholder }}</div>
      }
    </div>
  </div>

  <div class="md:col-span-6 pl-4">
    <label class="normal-font-size-bold flex mb-1">Contact Information</label>
    <div class="card-grid small-gap">
      <label>Street:</label>
      <div>{{ physicianTableData?.physicalStreet | emptyPlaceholder }}</div>

      <label>City:</label>
      <div>{{ physicianTableData?.physicalCity | emptyPlaceholder }}</div>

      <label>State:</label>
      <div>{{ physicianTableData?.physicalState | emptyPlaceholder }}</div>

      <label>ZIP Code:</label>
      <div>{{ physicianTableData?.physicalZip | emptyPlaceholder }}</div>

      <label>Phone:</label>
      <div>{{ physicianTableData?.phone | emptyPlaceholder }}</div>
    </div>
  </div>
</div>
